export const fixedHeight = {
  height: '70vh',
}
